import { Button } from 'reactstrap'

export default function FileClearButton({ handleInputChange }) {
  console.log('FileClearButton rendered')

  function handleClear() {
    const event = {
      target: {
        value: '',
        files: [],
      }
    }
    handleInputChange(event)
  }

  return (
    <Button style={{ marginLeft: '10px' }} size="sm" color="warning" onClick={handleClear}>Clear</Button>
  )
}
